import {Platform} from 'react-native';
import {

  getStatusBarHeight,
  isIphoneX,
} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {css} from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

interface Check {
  checked?: boolean;
}

export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  z-index: 1;

`;

export const Content = styled.View`
  padding: 0 24px;

`;

export const Form = styled.View``;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const BankInputContainer = styled.View`
  flex-direction: row;
  align-items: flex-end;
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
`;

const bankDropdownMarginRight = Platform.select({
  android: RFValue(-14),
  ios: RFValue(-8),
});

const bankDropdownMarginBottom = Platform.select({
  android: RFValue(0),
  ios: RFValue(-2),
});

export const BankDropdownButton = styled.TouchableOpacity`
  height: ${RFValue(45)}px;
  width: ${RFValue(28)}px;
  margin-right: ${bankDropdownMarginRight}px;
  margin-bottom: ${bankDropdownMarginBottom}px;
  align-items: center;
  justify-content: center;
`;

export const BankDropdownIcon = styled(Feather)`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const InputRow = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Input = styled.TextInput`
  background-color: #000;
`;

export const Footer = styled.View`
  padding: 0 24px;
  background-color: ${({theme}) => theme.colors.background};
  padding-top: ${RFValue(6)}px;

  width: 100%;
  padding-bottom: ${!isIphoneX() ? RFValue(20) : 0}px;
`;

export const StatusBarMask = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${getStatusBarHeight() + RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background};
  z-index: 2;
`;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.placeholder};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const TermContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${RFValue(12)}px;
`;

export const TermLinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const TermLinkText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const TermCheckButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const TermContainerBox = styled.View`
  flex-direction: column;
`;

export const TermCheckIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.text};
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const TypeContainer = styled.View`
  margin: 0 -24px;
`;

export const CardContainer = styled.TouchableHighlight`
  padding: 0 24px;
  flex-direction: row;
  height: ${RFValue(50)}px;
  justify-content: space-between;
  align-items: center;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
`;

export const CardTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const CardButtonIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const InputSpan = styled.Text`
    font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  margin-top: -6px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const PixWarningText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.red};
  margin-top: ${RFValue(4)}px;
  margin-bottom: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BankSelectorLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

interface BankSelectorValueProps {
  isPlaceholder?: boolean;
}

export const BankSelectorValue = styled.Text<BankSelectorValueProps>`
  flex: 1;
  font-size: ${RFValue(12)}px;
  color: ${({isPlaceholder, theme}) =>
    isPlaceholder ? theme.colors.placeholder : theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BankSheetTitle = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.title};
  padding: ${RFValue(20)}px ${RFValue(24)}px ${RFValue(8)}px;
`;

export const SearchForm = styled.View`
  margin: 0 24px;
`;

export const BankSheetItem = styled.TouchableOpacity`
  padding: ${RFValue(14)}px ${RFValue(24)}px;
  border-bottom-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const BankSheetItemText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BankSheetEmpty = styled.Text`
  text-align: center;
  padding: ${RFValue(20)}px;
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.placeholder};
  font-family: ${({theme}) => theme.fonts.regular};
`;
